import React from "react";
import { NavLink } from "react-router-dom";
import './styles.css';

function SubTabsDashboard() {
  return (
    <div className="scrollable-container-app">
      <ul className="nav nav-tabs">
      <li className="nav-item">
          <NavLink
            to="/dashboard/budget-logistics"
            className="nav-link"
            activeClassName="active"
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
          >
            Budget Logistics
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="/dashboard/stock"
            className="nav-link"
            activeClassName="active"
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
          >
            Stock
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="/dashboard/stock-items"
            className="nav-link"
            activeClassName="active"
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
          >
            Stock Items
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="/dashboard/supplier-purchase-plan"
            className="nav-link"
            activeClassName="active"
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
          >
            Supplier Purchase Plan
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="/dashboard/history"
            className="nav-link"
            activeClassName="active"
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
          >
            History
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="/dashboard/budget-analysis"
            className="nav-link"
            activeClassName="active"
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
          >
            Budget Analysis
          </NavLink>
        </li>

      </ul>
    </div>
  );
}

export default SubTabsDashboard;
